import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import Menu from 'yxyweb/common/components/basic/menu';

import * as treeactions from 'yxyweb/common/redux/tree';
import * as tabsactions from 'yxyweb/common/redux/tabs';
import * as portalactions from 'yxyweb/common/redux/portal';
import { getPredicateValue } from '../../helpers/util';

class LeftMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyField: 'code',
      titleField: 'name'
    };
    this.windows = {};
    // if (!props.reload) return;
    // let { treeactions } = this.props;
    // this.newtreeid = 0;
    // treeactions.treeload(() => {
    //   this.newtreeid++;
    // });
  }
  componentDidMount() {
    const { treeactions } = this.props;
    treeactions.setHandler(this.handleClick);
    window.onbeforeunload = this.onBeforeUnload;
  }
  componentWillUnmount() {
    this.onBeforeUnload();
  }
  onBeforeUnload = () => {
    if (window.Electron && cb.electron.getSharedObject('programConfig')) {
      const menuIds = [];
      for (var attr in this.windows)
        menuIds.push(attr);
      if (!menuIds.length) return;
      cb.electron.sendOrder('closeWindow', menuIds);
      return;
    }
    for (var attr in this.windows)
      this.windows[attr].close();
  }
  windowOpen(menuId, viewType, fullscreen, callback, external) {
    let currentWindow = this.windows[menuId];
    if (currentWindow && !currentWindow.closed) {
      currentWindow.focus();
      if (fullscreen)
        currentWindow.resizeTo(screen.availWidth, screen.availHeight)
      return;
    }
    let url = callback();
    if (url === false) return;
    url = getPredicateValue(url);
    if (window.Electron && cb.electron.getSharedObject('programConfig')) {
      const needNative = this.checkConditionUrl(url, viewType);
      if (url.indexOf('http://') < 0 && url.indexOf('https://') < 0)
        url = cb.rest.AppContext.serviceUrl + url;
      if (external) {
        // cb.electron.sendOrder('openExternal', url);
        // this.windows[menuId] = false;
        cb.utils.loadingControl.start();
        let width = 0, height=0;
        try{
          width = window.screen.width;
          height = window.screen.height;
        }catch(e){}
        cb.electron.sendOrder('openWindow', { url, menuId, width, height, needNative }).then(() => {
          cb.utils.loadingControl.end();
          this.windows[menuId] = false;
        });
      } else {
        cb.utils.loadingControl.start();
        cb.electron.sendOrder('openWindow', { url, menuId, needNative }).then(() => {
          cb.utils.loadingControl.end();
          this.windows[menuId] = false;
        });
      }
      return;
    }
    const features = fullscreen ? 'fullscreen=yes' : null;
    currentWindow = window.open(url, menuId, features);
    this.windows[menuId] = currentWindow;
    if (fullscreen)
      currentWindow.resizeTo(screen.availWidth, screen.availHeight);
  }
  handleWindow(viewType, menuUrl, menuId, fullscreen, isSystem) {
    if (!menuUrl) {
      cb.utils.alert('menuUrl为空', 'warning');
      return;
    }
    if (viewType === 'ajax') {
      this.windowOpen(menuId, viewType, fullscreen, function () {
        const proxy = cb.rest.DynamicProxy.create({ getUrl: { url: menuUrl, method: 'GET', options: { async: false } } });
        const data = proxy.getUrl();
        if (!data.error)
          return data.result;
        cb.utils.alert(data.error.message, 'error');
        return false;
      }, true);
    } else {
      this.windowOpen(menuId, viewType, fullscreen, function () {
        if (!cb.events.execute('menuClick', menuId))
          return false;
        return menuUrl;
      }, isSystem === false ? true : false);
    }
  }
  onClick = (selectedKeys) => {
    if (selectedKeys.length !== 1) return;
    this.props.treeactions.execHandler(selectedKeys[0]);
  }
  handleClick = (activeKey, selectedNode, filterCondition) => {
    try {
      const properties = {
        entry_mode: 'menu',
        function_id: selectedNode.code || '',
        function_name: selectedNode.name || '',
      }
      window.AnalysysAgent.track("function_click", properties)
    } catch(e) {
      console.log(e)
    }
    const menuId = selectedNode[this.state.keyField];
    if (!menuId) {
      cb.utils.alert('menuId为空', 'warning');
      return;
    }
    const { tabsactions, portalactions, tabs, portal } = this.props;
    const index = tabs.panes.findIndex(pane => {
      return pane.key === activeKey;
    });
    const { viewType, isSystem } = selectedNode;
    if (viewType === 'external' || viewType === 'ajax') {
      const { menuUrl, metaType } = selectedNode;
      let config = null;
      try {
        config = JSON.parse(metaType);
      } catch (e) {
        cb.utils.alert(e.message, 'warning');
        config = {};
      }
      if (config.type === 'window')
        return this.handleWindow(viewType, menuUrl, menuId, config.mode === 'fullscreen', isSystem);
    }
    let keepFilter = true;
    if (filterCondition && filterCondition.filterId === null) {
      keepFilter = false;
      delete filterCondition.filterId;
    }
    if (index > -1) {
      tabsactions.activateItem(activeKey);
      const current = portal.tabs[activeKey];
      if (!current) return;
      const currentPanes = current.panes;
      if (!currentPanes || !currentPanes.length) return;
      if (filterCondition) {
        if (currentPanes.length === 1) {
          currentPanes[0].content.vm.execute('updateCondition', filterCondition);
          return;
        }
      } else {
        if (currentPanes.length === 1) return;
      }
      const activeContent = currentPanes[currentPanes.length - 1].content;
      if (!activeContent) return;
      if (activeContent.vm) {
        activeContent.vm.promiseExecute('return', '返回', function () {
          portalactions.firstItem(activeKey);
        });
      } else if (activeContent.type && activeContent.url) {
        if (activeContent.checkReturn) {
          portalactions.refreshItem(activeKey, '返回', function () {
            portalactions.firstItem(activeKey);
          });
        } else {
          portalactions.firstItem(activeKey);
        }
      }
      if (filterCondition)
        currentPanes[0].content.vm.execute('updateCondition', filterCondition);
      return;
    }
    let params = Object.assign({}, selectedNode, {
      userClick: true,
      menuId: menuId
    });
    let callback = (returnData) => {
      if (filterCondition) {
        var vm = returnData.content.vm;
        vm.getParams().outCondition = true;
        vm.getParams().condition = filterCondition;
        if (!keepFilter)
          vm.getParams().filterId = null;
      }
      tabsactions.addItem(returnData);
    };
    cb.loader.runCommandLine('menu', params, null, callback);
  }
  checkConditionUrl = (url, viewType) => {
    if (url == '/billing')
      return true
    if (viewType === 'ajax')
      return false
    return true
  }
  render() {
    let treeData = this.props.tree.TreeData;
    if (!treeData.length)
      return null;
    let trigger = 'hover';
    if (process.env.__CLIENT__) {
      cb.rest.AppContext.portalTreeData = treeData;
      if (cb.rest.device === 'android')
        trigger = 'click';
    }
    return (
      <div>
        <Menu trigger={trigger} defaultSelectedKeys={['PORTAL']} titleField={this.state.titleField} keyField={this.state.keyField}
          dataSource={treeData} onSelect={this.onClick}
          id={`menu${this.props.tree.id}`} />
        {/*<div className="bottom-setting">
          <a><Icon type="help" /></a>
          <a><Icon type="service" /></a>
          <a><Icon type="setting" /></a>
        </div>*/}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    tree: state.tree.toJS(),
    tabs: state.tabs.toJS(),
    portal: state.portal.toJS()
  }
}

function mapDispatchToProps(dispatch) {
  return {
    treeactions: bindActionCreators(treeactions, dispatch),
    tabsactions: bindActionCreators(tabsactions, dispatch),
    portalactions: bindActionCreators(portalactions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenu);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/portal/LeftMenu.jsx